export function required(fieldValue: string) {
  return fieldValue ? undefined : 'Please enter a value';
}
